module.exports = __webpack_public_path__ + "static/media/Gallery 3.bc2a0b54.svg";